/*
 * Copyright (c) 2020.  Sanish Manandhar
 * All Rights Reserved
 */
export const COMPANY_CLEAN_REQUEST = 'COMPANY_CLEAN_REQUEST';

export const COMPANY_SECRET_CLEAN_REQUEST = 'COMPANY_SECRET_CLEAN_REQUEST';

export const COMPANY_FETCH_REQUEST = 'COMPANY_FETCH_REQUEST';
export const COMPANY_FETCH_REQUEST_SUCCESS = 'COMPANY_FETCH_REQUEST_SUCCESS';
export const COMPANY_FETCH_REQUEST_FAILURE = 'COMPANY_FETCH_REQUEST_FAILURE';

export const COMPANY_UPSERT_REQUEST = 'COMPANY_UPSERT_REQUEST';
export const COMPANY_UPSERT_REQUEST_SUCCESS = 'COMPANY_UPSERT_REQUEST_SUCCESS';
export const COMPANY_UPSERT_REQUEST_FAILURE = 'COMPANY_UPSERT_REQUEST_FAILURE';

export const COMPANY_REGISTRATION_REQUEST = 'COMPANY_REGISTRATION_REQUEST';
export const COMPANY_REGISTRATION_REQUEST_SUCCESS = 'COMPANY_REGISTRATION_REQUEST_SUCCESS';
export const COMPANY_REGISTRATION_REQUEST_FAILURE = 'COMPANY_REGISTRATION_REQUEST_FAILURE';

export const COMPANY_REGISTRATION_COMPLETE_REQUEST = 'COMPANY_REGISTRATION_COMPLETE_REQUEST';
export const COMPANY_REGISTRATION_COMPLETE_REQUEST_SUCCESS =
  'COMPANY_REGISTRATION_COMPLETE_REQUEST_SUCCESS';
export const COMPANY_REGISTRATION_COMPLETE_REQUEST_FAILURE =
  'COMPANY_REGISTRATION_COMPLETE_REQUEST_FAILURE';

export const COMPANY_REGISTRATION_SECRET_REQUEST = 'COMPANY_REGISTRATION_SECRET_REQUEST';
export const COMPANY_REGISTRATION_SECRET_REQUEST_SUCCESS =
  'COMPANY_REGISTRATION_SECRET_REQUEST_SUCCESS';
export const COMPANY_REGISTRATION_SECRET_REQUEST_FAILURE =
  'COMPANY_REGISTRATION_SECRET_REQUEST_FAILURE';

export const COMPANY_EMAIL_PROCESS = 'COMPANY_EMAIL_PROCESS';
export const COMPANY_EMAIL_PROCESS_SUCCESS = 'COMPANY_EMAIL_PROCESS_SUCCESS';
export const COMPANY_EMAIL_PROCESS_FAILURE = 'COMPANY_EMAIL_PROCESS_FAILURE';

export const COMPANY_STRIPE_KEY_VALIDATION_REQUEST = 'COMPANY_STRIPE_KEY_VALIDATION_REQUEST';
export const COMPANY_STRIPE_KEY_VALIDATION_REQUEST_SUCCESS =
  'COMPANY_STRIPE_KEY_VALIDATION_REQUEST_SUCCESS';
export const COMPANY_STRIPE_KEY_VALIDATION_REQUEST_FAILURE =
  'COMPANY_STRIPE_KEY_VALIDATION_REQUEST_FAILURE';

export const QUICKBOOK_SIGNUP_UPDATE_REQUEST = 'QUICKBOOK_SIGNUP_UPDATE_REQUEST';
export const QUICKBOOK_SIGNUP_UPDATE_REQUEST_SUCCESS = 'QUICKBOOK_SIGNUP_UPDATE_REQUEST_SUCCESS';
export const QUICKBOOK_SIGNUP_UPDATE_REQUEST_FAILURE = 'QUICKBOOK_SIGNUP_UPDATE_REQUEST_FAILURE';

export const QUICKBOOK_LOGIN_STATUS_FETCH_REQUEST = 'QUICKBOOK_LOGIN_STATUS_FETCH_REQUEST';
export const QUICKBOOK_LOGIN_STATUS_FETCH_REQUEST_SUCCESS =
  'QUICKBOOK_LOGIN_STATUS_FETCH_REQUEST_SUCCESS';
export const QUICKBOOK_LOGIN_STATUS_FETCH_REQUEST_FAILURE =
  'QUICKBOOK_LOGIN_STATUS_FETCH_REQUEST_FAILURE';

export const QUICKBOOK_SIGNIN_UPDATE_REQUEST = 'QUICKBOOK_SIGNIN_UPDATE_REQUEST';
export const QUICKBOOK_SIGNIN_UPDATE_REQUEST_SUCCESS = 'QUICKBOOK_SIGNIN_UPDATE_REQUEST_SUCCESS';
export const QUICKBOOK_SIGNIN_UPDATE_REQUEST_FAILURE = 'QUICKBOOK_SIGNIN_UPDATE_REQUEST_FAILURE';

export const COMPANY_DROPDOWN_FETCH_REQUEST = 'COMPANY_DROPDOWN_FETCH_REQUEST';
export const COMPANY_DROPDOWN_FETCH_REQUEST_SUCCESS = 'COMPANY_DROPDOWN_FETCH_REQUEST_SUCCESS';
export const COMPANY_DROPDOWN_FETCH_REQUEST_FAILURE = 'COMPANY_DROPDOWN_FETCH_REQUEST_FAILURE';

export const FETCH_ONBOARDING_COMPANIES_REQUEST = 'FETCH_ONBOARDING_COMPANIES_REQUEST';
export const FETCH_ONBOARDING_COMPANIES_REQUEST_SUCCESS =
  'FETCH_ONBOARDING_COMPANIES_REQUEST_SUCCESS';
export const FETCH_ONBOARDING_COMPANIES_REQUEST_FAILURE =
  'FETCH_ONBOARDING_COMPANIES_REQUEST_FAILURE';

export const DELETE_ONBOARDING_COMPANY_REQUEST = 'DELETE_ONBOARDING_COMPANY_REQUEST';
export const DELETE_ONBOARDING_COMPANY_REQUEST_SUCCESS =
  'DELETE_ONBOARDING_COMPANY_REQUEST_SUCCESS';
export const DELETE_ONBOARDING_COMPANY_REQUEST_FAILURE =
  'DELETE_ONBOARDING_COMPANY_REQUEST_FAILURE';

export const UPDATE_ONBOARDING_COMPANY_REQUEST = 'UPDATE_ONBOARDING_COMPANY_REQUEST';
export const UPDATE_ONBOARDING_COMPANY_REQUEST_SUCCESS =
  'UPDATE_ONBOARDING_COMPANY_REQUEST_SUCCESS';
export const UPDATE_ONBOARDING_COMPANY_REQUEST_FAILURE =
  'UPDATE_ONBOARDING_COMPANY_REQUEST_FAILURE';

export const ONBOARDING_COMPANY_DETAIL_FETCH_REQUEST = 'ONBOARDING_COMPANY_DETAIL_FETCH_REQUEST';
export const ONBOARDING_COMPANY_DETAIL_FETCH_REQUEST_SUCCESS =
  'ONBOARDING_COMPANY_DETAIL_FETCH_REQUEST_SUCCESS';
export const ONBOARDING_COMPANY_DETAIL_FETCH_REQUEST_FAILURE =
  'ONBOARDING_COMPANY_DETAIL_FETCH_REQUEST_FAILURE';
export const REFERRAL_REGISTRATION_REQUEST = 'REFERRAL_REGISTRATION_REQUEST';
export const REFERRAL_REGISTRATION_REQUEST_SUCCESS = 'REFERRAL_REGISTRATION_REQUEST_SUCCESS';
export const REFERRAL_REGISTRATION_REQUEST_FAILURE = 'REFERRAL_REGISTRATION_REQUEST_FAILURE';
export const REFERRAL_CLEAN_REQUEST = 'REFERRAL_CLEAN_REQUEST';
